import React from 'react';
import { Heading } from 'components/chroma';
import styled from 'styled-components';

type TotalLossHeaderWrapperProps = {
  size: number;
};
export const TotalLossHeaderWrapper = styled.div`
  ${(props: TotalLossHeaderWrapperProps) =>
    `h${props.size} { 
      font-size: 0.90rem; 
    }`};
`;

export const totalLossSettlementHeading = (totalLossHeaderSize: number = 4) => (
  <TotalLossHeaderWrapper size={totalLossHeaderSize}>
    <Heading size={totalLossHeaderSize} margin={{ bottom: 2 }}>
      How we settle a total loss claim
    </Heading>
  </TotalLossHeaderWrapper>
);
